exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.niceBox[data-v-55ce4ec7] {\n  padding: 0 0.6rem;\n}", ""]);

// exports
